import moment from 'moment';
import db from '@/store/db';
import log from '@/logger';
import { sanitizeCommentText } from '@/common/htmlHelper';

export default {
  getDefaultPartComment: (projectId, partId) => {
    return {
      projectId: projectId,
      partId: partId,
      type: 'PartComment',
      commentdate: moment().format('YYYY-MM-DD HH:mm:ss'),
      archived: false,
      title: '',
      text: '',
      authorPersonId: '',
      authorUsername: '',
    };
  },
  createPartComment: function ({ projectId, part, text, authorPersonId, authorUsername }) {
    text = sanitizeCommentText(text);
    var mentions = {};
    var regex = new RegExp('<span[^>]*data-id="([^"]+)"[^>]*>([^<]+)</span>', 'gi');
    var match;
    while ((match = regex.exec(text)) !== null) {
      mentions[match[1]] = match[2];
    }

    var newPartComment = Object.assign({}, this.getDefaultPartComment(projectId, part._id), {
      text,
      title: part.title,
      authorPersonId,
      authorUsername,
      mentions: mentions,
    });

    return db.currentProjectDb.post(newPartComment).then(function (doc) {
      newPartComment._id = doc.id;
      newPartComment._rev = doc.rev;

      return newPartComment;
    });
  },
  getPartComments: function (projectId, partId) {
    return db.currentProjectDb
      .query('partComments', {
        include_docs: true,
        startkey: [projectId, partId, '', ''],
        endkey: [projectId, partId, '\ufff0', '\ufff0'],
      })
      .then((result) => {
        var populated = [];
        for (var row of result.rows) {
          var partComment = Object.assign(this.getDefaultPartComment(projectId, partId), row.doc);

          populated.push(partComment);
        }

        return populated;
      })
      .catch(function (err) {
        log.error('Unable to load partComments', err);
        throw err;
      });
  },
  getPartCommentsForPerson: function (personId) {
    return db.userDb
      .query('partCommentsForPerson', {
        include_docs: true,
        descending: true,
        endkey: [personId, moment().add(-4, 'week').format('YYYY-MM-DD')],
        startkey: [personId, '9999-09-09'],
      })
      .then((result) => {
        var populated = [];
        for (var row of result.rows) {
          var partComment = Object.assign(this.getDefaultPartComment(row.doc.projectId, row.doc.partId), row.doc);

          populated.push(partComment);
        }

        return populated;
      })
      .catch(function (err) {
        log.error('Unable to load partCommentsForPerson', err);
        throw err;
      });
  },
};



// WEBPACK FOOTER //
// ./src/store/partComment/partCommentApi.js